/**
 * 扩大选区 / 选取相似（对比 Photoshop 补全第一档缺口 阶段 2）。
 *
 * 跟 `selection-from-source.ts` 的 `loadCompositeChannelSelection` 同款
 * 模式：读 `store.selection`、在文档合成结果上算新 mask、写回
 * `store.setSelection`——选区是应用层会话状态，不进 Command Bus、不进
 * 历史（DESIGN.md §6.2；跟反选/全选/取消选择同一惯例）。
 */
import { grow, similar } from '../engine/selection/ops';
import { compositeDocument } from './composite';
import type { AppStore } from './store';

/** 扩大选区。无文档或无选区时什么都不做，返回 false。 */
export async function growSelection(store: AppStore, tolerance: number): Promise<boolean> {
  const document = store.document;
  const current = store.selection;
  if (document === null || current === null) return false;
  const composite = compositeDocument(document, store.tiles);
  const grown = await grow(composite, current, tolerance);
  store.setSelection(grown);
  return true;
}

/** 选取相似。无文档或无选区时什么都不做，返回 false。 */
export async function similarSelection(store: AppStore, tolerance: number): Promise<boolean> {
  const document = store.document;
  const current = store.selection;
  if (document === null || current === null) return false;
  const composite = compositeDocument(document, store.tiles);
  const extended = await similar(composite, current, tolerance);
  store.setSelection(extended);
  return true;
}
